export const withoutSipCredentialMetadata = (integrations: any) => {
  if (!integrations?.sip) return integrations;
  const result = { ...integrations };
  const sip = { ...result.sip };
  delete sip.token_configured;
  if (Object.keys(sip).length > 0) result.sip = sip;
  else delete result.sip;
  return result;
};
